import { Link } from "react-router-dom";
import NewsCard from "@/components/feature/NewsCard";
import { newsList } from "@/mocks/news";
import { formatChineseDate } from "@/utils/format";

export default function HomeNewsSection() {
  const latest = newsList.slice(3, 8);
  const sideFeature = newsList[1];
  const quickList = newsList.slice(8, 12);

  return (
    <section className="w-full bg-background-50 px-4 py-14 md:px-8 md:py-20 lg:px-12">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_340px]">
        <div>
          <div className="mb-8 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
            <div>
              <div className="flex items-center gap-2 text-[11px] font-medium uppercase tracking-[0.28em] text-primary-600">
                <span className="h-[1px] w-6 bg-primary-400"></span>
                Latest News
              </div>
              <h2 className="mt-3 font-heading text-2xl font-semibold text-foreground-950 md:text-[30px]">
                新闻精选
              </h2>
              <p className="mt-2 text-sm text-foreground-600">按发布时间整理的最新五条动态，快速掌握近期节奏。</p>
            </div>
            <Link
              to="/news"
              className="inline-flex w-fit cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full border border-background-300 px-4 py-2 text-xs text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
            >
              查看全部新闻
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>

          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
            {latest.map((item) => (
              <NewsCard key={item.id} item={item} />
            ))}
            <Link
              to="/news"
              className="group relative flex min-h-[180px] flex-col justify-between overflow-hidden rounded-lg bg-background-100 p-5"
            >
              <div>
                <p className="text-[11px] uppercase tracking-[0.25em] text-primary-600">全部归档</p>
                <p className="mt-3 font-heading text-lg font-semibold leading-8 text-foreground-900">
                  共 {newsList.length} 篇资讯
                  <br />
                  按时间与类型整理
                </p>
              </div>
              <div className="flex items-center gap-2 text-sm text-primary-700">
                进入新闻频道
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-500 text-background-50 transition-transform duration-300 group-hover:translate-x-1">
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </span>
              </div>
            </Link>
          </div>
        </div>

        <aside className="flex flex-col gap-6">
          <Link
            to={`/news/${sideFeature.id}`}
            className="group relative block overflow-hidden rounded-lg"
          >
            <div className="h-56 w-full overflow-hidden bg-background-200">
              <img
                src={sideFeature.cover}
                alt={`${sideFeature.title} - 张柏芝新闻配图`}
                title={`${sideFeature.title} - 张柏芝新闻`}
                className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/20 to-transparent"></div>
            <div className="absolute inset-x-0 bottom-0 p-5">
              <span className="rounded-full bg-accent-500 px-2.5 py-0.5 text-[11px] text-background-50">
                重点报道
              </span>
              <h3 className="mt-2.5 font-heading text-base font-semibold leading-7 text-background-50">
                {sideFeature.title}
              </h3>
              <p className="mt-1.5 text-[11px] text-background-300">
                {formatChineseDate(sideFeature.publishedAt)} · {sideFeature.source}
              </p>
            </div>
          </Link>

          <div className="rounded-lg border border-background-200 bg-background-100 p-5">
            <h3 className="flex items-center gap-2 text-sm font-medium text-foreground-900">
              <span className="flex h-6 w-6 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className="ri-flashlight-line text-sm" aria-hidden="true"></i>
              </span>
              更多动态
            </h3>
            <ul className="mt-3">
              {quickList.map((item, i) => (
                <li key={item.id}>
                  <Link
                    to={`/news/${item.id}`}
                    className="group flex items-start gap-3 border-b border-background-200/80 py-3 last:border-b-0"
                  >
                    <span className="font-heading text-xs text-primary-500">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="line-clamp-2 flex-1 text-[13px] leading-6 text-foreground-700 transition-colors group-hover:text-primary-700">
                      {item.title}
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </aside>
      </div>
    </section>
  );
}